<template>
  <ValidationProvider
    :rules="validate || ''"
    v-slot="v"
  >
    <div
      class="form-group"
      :class="{'has-warning':  v.errors[0] !== ''}"
    >
      <div :class="{'form-group row': inline, 'red-border': isredborder}">
        <div :class="{'col-sm-2 mt-1': inline}">
          <label
            v-if="label"
            :for="name"
            class="control-label"
            :class="{'mr-1': inline}"
          >
            {{label}}:
            <span
              class="text-danger"
              v-if="hasAsterisk"
            >*</span>
          </label>
        </div>
        <template v-if="disabled">
          <div :class="{'col-sm-10': inline}">
            <input
              class="form-control"
              :name="name"
              :placeholder="label"
              :value="disabledText"
              disabled
            />
          </div>
        </template>
        <template v-else>
          <div :class="{'col-sm-10': inline}">
            <select
              :name="name"
              v-model="selected"
              @change="change"
              class="custom-select"
              :tabindex="tabindex"
            >
              <option
                :value="option.value"
                v-for="(option, index) of options"
                :key="index"
              >
                {{option.name}}
              </option>
            </select>
            <small
              class="text-danger"
              v-if="v.errors[0] !== ''"
            >
              {{ v.errors[0] }}
            </small>
          </div>
        </template>
      </div>
    </div>
  </ValidationProvider>
</template>
<script>
import _ from 'lodash'
export default {
  name: 'dt-select',
  props: {
    name: String,
    value: [Number, String, Boolean],
    label: String,
    validate: String,
    disabled: Boolean,
    readonly: Boolean,
    options: Array,
    inline: {
      type: Boolean,
      default: false
    },
    isredborder: {
      type: Boolean,
      default: false
    },
    tabindex: [Number, String]
  },
  computed: {
    selected: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    },
    rules() {
      let _rules = ''
      if (this.validate && this.validate.includes('required')) {
        if (this.options !== undefined && this.options !== null) {
          // let _items = ''
          // this.options.forEach(option => {
          //   if (_items !== '') {
          //     _items += ','
          //   }
          //   _items += option.value
          // })
          // _rules = `oneOf:${_items}`
        }
      }
      return _rules
    },
    hasAsterisk() {
      return this.validate && this.validate.includes('required')
    },
    disabledText() {
      if (this.options && this.options.length) {
        let options = this.options.filter(
          option => _.toString(option.value) === _.toString(this.value)
        )
        return options.length ? options[0].name : this.value
      }
      return this.value
    }
  },
  methods: {
    change($event) {
      this.$emit('input', $event.target.value)
      this.$emit('change')
    }
  }
}
</script>

<style scoped="true">
input:disabled {
  cursor: text;
}
.red-border {
  border: solid 1px red;
  padding-top: 5px;
  padding-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/utilities/form/dt-select.vue